'use strict';

var findIndexBy = require('./findIndexBy');

function findIndexByName(arr, name) {
    return findIndexBy(arr, function (info) {
        return info.name === name;
    });
}

module.exports = findIndexByName;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-datagrid/lib/utils/findIndexByName.js
 ** module id = 916
 ** module chunks = 0
 **/